import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.poster}
          alt={`${movie.title} - 屁屁影院高清在线观看`}
          title={`${movie.title} - 屁屁影院免费观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-background-50">
            {movie.rating}
          </span>
        </div>
        {movie.tags[0] && (
          <div className="absolute top-2 right-2">
            <span className="inline-block px-2 py-0.5 text-xs font-medium rounded bg-background-950/70 text-background-50">
              {movie.tags[0]}
            </span>
          </div>
        )}
      </div>

      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{movie.year}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{movie.duration}</span>
        </div>
      </div>
    </Link>
  );
}